import axios from "@/plugins/axios";

let url = "/api/console/statistics/sessions";

export const sessions = {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};

export default sessions;
